import { Injectable } from "@angular/core";
import { EventTypes, OidcSecurityService, PublicEventsService } from "angular-auth-oidc-client";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { filter, Observable } from "rxjs";
import { DaoService } from "../../core/dao/dao.service";
import { AudioProcessorTask, IAudioProcessorTask } from "../../core/models/audio-processor-task.model";
import { IAudioPlugin } from "../../core/models/plugin.model";

@Injectable({
  providedIn: 'root',
})

export class TaskModel {

  public plugins: IAudioPlugin[] = [];
  public task: IAudioProcessorTask = null as any;
  public statusMessage!: string;
  public copyBlockSettingsObservable!: Observable<any>;

  constructor(
    private dao: DaoService,
    private toastr: ToastrService,
    private oidcSecurityService: OidcSecurityService,
    private loader: NgxUiLoaderService
  ) {
    const interval = setInterval(() => {
      this.oidcSecurityService.getAccessToken().subscribe(token => {
        if (token) {
          this.getPlugins();
          clearInterval(interval);
        }
      })
    }, 300)

  }

  createNewTask(plugin: IAudioPlugin) {
    this.loader.stop();
    this.task = new AudioProcessorTask();
    this.task.plugin = plugin;
    this.copyBlockSettingsObservable = new Observable((data) => {
      let blocks = this.task.taskBlocks;
      for (var i = 0; i < blocks.length; i++) {
        blocks[i].plugin = plugin;
        blocks[i].pluginId = plugin.id;
      }
    });
  }

  clearTask() {
    this.task = null as any;
  }

  hasTask() {
    return this.task != null;
  }

  getPlugins() {
    this.loader.start();
    const promise = new Promise((resolve, reject) => {
      this.dao.GetPlugins()
        .subscribe(result => {
          this.plugins = result;
          for (let p in this.plugins) {
            let element = this.plugins[p];
            let promises: any = [];
            const thumbnailBlob = new Blob([element.thumbnail], {
              type: 'text/plain'
            });
            const logoBlob = new Blob([element.logo], {
              type: 'text/plain'
            });
            thumbnailBlob.text().then(result => {
              element.thumbnailBlobUrl = 'data:image/png;base64,' + result
            })
            logoBlob.text().then(result => {
              element.logoBlobUrl = 'data:image/png;base64,' + result
            })

            for (var i = 0; i < element.menuItems.length; i++) {
              let menuItem = element.menuItems[i];
              if (menuItem.blob) {
                const blob = new Blob([menuItem.blob], {
                  type: 'text/plain'
                });
                promises.push(blob.text());
              }
            }

            Promise.all(promises)
              .then(urls => {
                let menuItems = element.menuItems.filter(item => { return item.menuId === 2 });
                for (var i = 0; i < urls.length; i++) {
                  let url = urls[i];
                  let menuItem = menuItems[i];
                  menuItem.blobUrl = 'data:image/jpg;base64,' + url;
                }
                this.plugins[p] = element;
              })
              .finally(() => {
                resolve(null);
              })

          }
        }, error => {
          this.toastr.error("An error occurred retrieving the list of plugins", "Plugin");
        }, () => {

        })

    });

    promise.then(() => {
      this.loader.stop();
    })

  }
}
